var ScriptLoader = /** @class */ (function () {
    function ScriptLoader() {
    }
    ScriptLoader.getScript = function (url, loadIntoHead) {
        var _this = this;
        this.promise = this.promise.then(function () { return _this.loadScriptUtil(url, loadIntoHead); });
        return this.promise;
    };
    ScriptLoader.loadScriptUtil = function (url, loadIntoHead) {
        var _this = this;
        if (window.google && window.google.maps && window.google.maps.places) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            _this.loadScriptAsync(url, loadIntoHead).then(function () {
                resolve(true);
            }, function (err) {
                reject(err);
            });
        });
    };
    ScriptLoader.loadScriptAsync = function (src, loadIntoHead) {
        var SCRIPT_ID = 'temp-script';
        return new Promise(function (resolve, reject) {
            if (typeof document === 'undefined') {
                // eslint-disable-next-line no-promise-executor-return
                return reject();
            }
            var prev = document.getElementById(SCRIPT_ID);
            if (prev) {
                prev.remove();
            }
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            script.async = true;
            script.defer = true;
            script.setAttribute('id', SCRIPT_ID);
            var appendTarget = loadIntoHead && !!loadIntoHead ? document.head : document.body;
            var cleanUp = function () {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                script.removeEventListener('load', onScriptLoad);
                appendTarget.removeChild(script);
            };
            var onScriptLoad = function () {
                cleanUp();
                return resolve();
            };
            var onScriptLoadError = function () {
                cleanUp();
                // eslint-disable-next-line prefer-promise-reject-errors
                return reject("Failed to load ".concat(src));
            };
            script.addEventListener('load', onScriptLoad);
            script.addEventListener('error', onScriptLoadError);
            appendTarget.appendChild(script);
        });
    };
    ScriptLoader.promise = Promise.resolve();
    return ScriptLoader;
}());

export { ScriptLoader };
